export enum MenuItemKey
{
    NotSet,
    Admin,
    Admin_Home,
    Admin_Platform,
    Admin_Platform_SystemOntologies,
    Admin_Platform_Packages,
    Admin_Platform_Solutions,
    Admin_Platform_Tenancies,
    Admin_Platform_Files,
    Admin_Tenancy,
    Admin_Tenancy_IdentityProviders,
    Admin_Tenancy_Roles,
    Admin_Tenancy_Users,
    Admin_Tenancy_Delegates,
    Admin_Tenancy_SolutionEnablement,
    Admin_DataExchange,
    Admin_DataExchange_Credentials,
    Admin_DataExchange_Publishers,
    Admin_DataModel,
    Admin_DataModel_TenancyOntologies,
    Admin_DataModel_Relationships,
    Admin_AssetsAndProcesses,
    Admin_AssetsAndProcesses_NodeHierarchy,
    Admin_AssetsAndProcesses_VirtualTreeViews,
}